// extracted by mini-css-extract-plugin
export default {"table":"_39Wwzp0SSnNLnUtd0k3C9K"};